import { fetchData } from "@/utils/requests";
import { create } from 'zustand';

interface Country {
    id: number,
    name: string;
    image_path: string
}

interface CountryStoreState {
    countries: Country[];
    loaded: boolean;
    countriesById: { [key: number]: Country };
}

const useCountryStore = create<CountryStoreState>((_set) => ({
    countries: [],
    loaded: false,
    countriesById: {},
}));

async function loadCountries() {
    useCountryStore.setState({ countries: [], loaded: true });
    fetchData('api/countries', (data) => {
        const countriesById = data.reduce((acc: { [key: number]: Country }, country: Country) => {
            acc[country.id] = country
            return acc;
        }, {});
        useCountryStore.setState({ countriesById });
        useCountryStore.setState({ countries: data, loaded: true });
    });
}

if (!useCountryStore.getState().loaded) loadCountries();

export { useCountryStore };